// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yaEOf","type":"styles_type__1WLTW","choices":"styles_choices__17JTk"};